
















































































































import ApiHelper from 'api-helper';
import { Vue, Component } from 'vue-property-decorator';
import Toast from '@common/helpers/toast';
import PageLoader from '@components/common/PageLoader.vue';
import Pagination from '@components/common/Pagination.vue';
import BasicSelect from '@components/common/BasicSelect.vue';
import ContentLayout from '@components/layouts/Content.vue';
import envelopeOpenTextIcon from '@/assets/img/envelopeOpenTextIcon.svg';
import _ from 'lodash';

const CONTACT_TYPE_OPTIONS = [
  { name: '診察について', value: 'medical_examination' },
  { name: '予約について', value: 'reservation' },
  { name: 'お支払いについて', value: 'payment' },
  { name: 'お薬について', value: 'medicine' },
  { name: '配送について', value: 'delivery' },
  { name: '定期配送のキャンセルについて', value: 'cancel_delivery' },
  { name: 'その他', value: 'other' },
];

@Component({
  components: {
    PageLoader,
    Pagination,
    BasicSelect,
    ContentLayout,
  },
  data() {
    return {
      iconHeader: envelopeOpenTextIcon,
    };
  },
})
export default class ContactList extends Vue {
  get isEmptyData(): boolean {
    return this.contacts && !this.contacts.length;
  }

  contacts: any[] = [];
  isLoading = false;
  isExporting = false;
  totalPage = 1;
  contactTypeOptions = CONTACT_TYPE_OPTIONS;

  paginate = {
    page: parseInt(this.$route.query.page as string) || 1,
    per_page: 20,
  };

  searchForm = {
    name: (this.$route.query.name as string) || '',
    email: (this.$route.query.email as string) || '',
    contact_type: (this.$route.query.contact_type as string) || '',
    per_page: 20,
    page: parseInt(this.$route.query.page as string) || 1,
  };

  mounted() {
    this.getContactList();
  }

  searchContacts() {
    this.searchForm.page = 1;
    this.paginate.page = 1;
    this.getContactList();
  }

  private async getContactList() {
    this.contacts = [];
    this.isLoading = true;

    this.setUrlWithQuery({ ...this.searchForm, ...this.paginate });

    await ApiHelper.getApi('ContactApi')
      .getContacts({ ...this.searchForm, ...this.paginate })
      .then((response: any) => {
        console.log(response);
        this.totalPage = response.last_page;
        this.contacts = response.data;
      })
      .catch((error: any) => {
        if (error.response && error.response.data) {
          Toast.error(error.response.data.message);
        }
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private async exportContacts(format: string) {
    this.isExporting = true;

    try {
      const params = {
        name: this.searchForm.name,
        email: this.searchForm.email,
        contact_type: this.searchForm.contact_type,
        format,
      };

      const response = await ApiHelper.getApi('ContactApi').exportContacts(
        params,
      );

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      const now = new Date();
      const timestamp = [
        now.getFullYear(),
        String(now.getMonth() + 1).padStart(2, '0'),
        String(now.getDate()).padStart(2, '0'),
        String(now.getHours()).padStart(2, '0'),
        String(now.getMinutes()).padStart(2, '0'),
        String(now.getSeconds()).padStart(2, '0'),
      ].join('');

      const ext = format === 'xlsx' ? 'xlsx' : 'csv';
      link.href = url;
      link.setAttribute('download', `contact_${timestamp}.${ext}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      Toast.success('ダウンロードが完了しました');
    } catch (error) {
      Toast.error('ダウンロードに失敗しました');
    } finally {
      this.isExporting = false;
    }
  }

  private pageChanged(page: number) {
    this.paginate = {
      ...this.paginate,
      page,
    };
    this.searchForm.page = page;
    this.getContactList();
  }

  private setUrlWithQuery(data: any) {
    const queryParams = _.pickBy({ ...this.$route.query, ...data }, _.identity);

    this.$router.push({
      path: this.$route.path,
      query: queryParams,
    });
  }
}
